import Vue from "vue";
import Vuetify from "vuetify/lib";
import zhHant from "vuetify/lib/locale/zh-Hant";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { "zh-Hant": zhHant },
    current: "zh-Hant",
  },
});
